import React, { useState, useEffect } from 'react';
import SVG from 'react-inlinesvg';
import { useNavigate, useSearchParams } from 'react-router-dom';
import IconSearch from '../../../../assets/images/reskin-images/icon--search.svg';

export default function SearchBar({ onSearchSubmit, isMobileDrawer = false }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [query, setQuery] = useState(searchParams.get('q') || '');
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    setQuery(searchParams.get('q') || '');
  }, [searchParams]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/v2/search?q=${encodeURIComponent(query.trim())}`);
      if (onSearchSubmit) {
        onSearchSubmit();
      }
    }
  };


  return (
    <form
      onSubmit={handleSubmit}
      className={`flex items-center bg-white border ${
        isFocused ? 'border-link-purple' : 'border-gray'
      } rounded-lg w-full transition-colors`}
      style={{ height: isMobileDrawer ? '36px' : '31px' }}
    >
      <div className="flex items-center flex-grow pl-3 pr-2 min-w-0">
        <SVG
          src={IconSearch}
          className={`w-5 h-5 mr-2 text-charcoal flex-shrink-0 transition-opacity duration-200 ${
            isFocused || query ? 'opacity-100' : 'opacity-50'
          }`}
        />
        <input
          type="text"
          id="playbook-search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder="Search content..."
          className="w-full text-sm text-charcoal placeholder-grey-dark bg-transparent outline-none focus:outline-none"
          style={{ border: 'none', padding: '0', boxShadow: 'none' }}
        />
      </div>
      <button
        type="submit"
        className={`bg-link-purple hover:bg-purple-500 text-white font-bold rounded-lg transition-colors cursor-pointer flex items-center justify-center flex-shrink-0 px-5 py-2 text-sm normal-case`}
        style={{ borderRadius: '8px' }}
      >
        Search
      </button>
    </form>
  );
}
